import { styled as muiStyled } from '@mui/material/styles';
import { Box, Button } from "@mui/material";
import { secondary } from "styles/theme";
import { thirdly4 } from 'styles/theme';
import { bg } from 'styles/theme';
import { ScrollCss } from 'styles/GlobalCss';
import { thirdly2 } from 'styles/theme';
import { borderRadius, boxSizing, display, fontSize, fontWeight, height, lineHeight, positions, textAlign } from '@mui/system';
import { secondary1 } from 'styles/theme';
import { error } from 'styles/theme';
import { thirdly5 } from 'styles/theme';
import { thirdly3 } from 'styles/theme';
import { gray } from 'styles/theme';
import { lightSecondary } from 'styles/theme';
import { ligthGray } from 'styles/theme';
import { dark } from 'styles/theme';
import { rating1 } from 'styles/theme';
import { thirdly } from 'styles/theme';

const rowRadius = 15

export const titleStyles = {
    fontSize: "1.2rem",
    fontWeight: "bold",
    marginBottom: 20
}

const sectionStyles = {
    background: thirdly4,
    borderRadius: 15,
    padding: 20,
    width: "100%",
    boxSizing: "border-box"
}


const rowStyles = {
    borderRadius: rowRadius,
    background: "white",
    padding: 10,
    width: "100%",
    boxSizing: "border-box"
}

export const HeaderStyles = muiStyled(Box)(({ }) => ({
    '.general-title': {
        color: secondary,
        fontSize: "1.1rem",
        fontWeight: "bold"
    },

    '.general-sub-title': {
        marginTop: 40,
        fontSize: "1.1rem",
        marginBottom: 7
    },
    '.general-sub-title1': {
        fontWeight: "bold",
        fontSize: "1.1rem",
    },
}));

export const StudentStyles = muiStyled(Box)(({ }) => ({
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
    '.assessment-source': {
        background: lightSecondary,
        border: `1px solid ${secondary}`,
        color: secondary
    },
    '.assessment-chip': {
        padding: 7,
        borderRadius: 5,
        border: `1px solid ${gray}`
    },
    '.exel-students': {
    },
    '.assessments-actions': {
        display: "flex",
        columnGap: 15
    },
    '.small-row-item': {
        width: "35% !important"
    },
    '.row-item': {
        width: "65%"
    },
    '.assessment-allocation-btn': {
        marginRight: 35,
        pointerEvents: "none"
    },
    '.section': {
        display: "flex",
        flexDirection: "column",
        rowGap: 35
    },
    '.edit-col': {
        marginRight: 10
    },
    '.edit-circle-border': {
        bottom: "-27px",
        left: "-29px"
    },
    '.checkbox-col': {
        bottom: "-28px",
        right: "-29px"
    },

    '.testtaker-export-list': {
        display: "flex",
        columnGap: 15
    },
    '.testtaker-export-list': {
        display: "flex"
    },
    '.export-exel': {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: 20
    },
    '.testtaker-list': {
        height: 130,
        width: 300,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    '.new-testtaker-popup': {
        height: 130,
        width: 240,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.testtakers': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.new-testtaker-row': {
        display: "flex",
        columnGap: 20
    },
    '.allocation-btn': {
        padding: 10,
        width: "100%",
        boxSizing: "border-box"
    },
    '.assessment-set': {
        height: 200,
        width: 190,
        borderRadius: 15,
        background: "white",
        padding: 10,
        border: "2px solid #FFFFFF",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        pointerEvents: "none"
    },
    '.assessment-set-items': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.select-assessment': {
        width: 245,
        height: 145,
        borderRadius: 5,
        background: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: 10
    },
    '.allocation-row-selected': {
        background: secondary,
        height: 20,
        width: 22,
        borderRadius: 7,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    '.allocation-row': {
        columnGap: 10,
        background: "white",
        border: `1px solid ${thirdly4}`,
        borderRadius: 3,
        width: "100%",
        height: 30,
        padding: "15px 15px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    '.wrap-select-assessments': {
        display: "flex",
        justifyContent: "space-between",
    },
    '.select-assessments': {
        display: "flex",
        columnGap: 15,
        flexWrap: "wrap",
        rowGap: 15
    },
    '.student-actions': {
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.add-testtaker': {
        display: "flex",
        flexDirection: "row !important",
        columnGap: 40
    },
    '.new-testtaker-rows': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.new-testtaker-actions': {
        display: "flex",
        justifyContent: "end",
        columnGap: 10,
        pointerEvents: "none"
    }

}));

export const PreformAssessmentStepsStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    fontSize: "1.1rem",
    '.wrap-assessment-in-book': {
        display: "flex",
        columnGap: 5,
        alignItems: "center"
    },
    '.assessment-in-book': {
        width: 100,
        height: 80
    },
    '.mic-icon': {
        width: 35,
        height: 35
    },
    '.preform-steps': {
        display: "flex",
        columnGap: 30
    },
    '.go-report': {
        color: dark,
        textDecoration: "underline",
        cursor: "pointer",
        ":hover": {
            opacity: 0.7
        }
    },
    '.step-card': {
        background: bg,
        borderRadius: 7,
        width: "9rem",
        height: "10rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center",
        padding: 15,
        flexDirection: "column",
        rowGap: 5
    },
    '.backdrop-numbers': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.backdrop-1': {
        color: "#CAD3DF",
        fontSize: 20,
        fontWeight: 700
    },
    '.record-actions': {
        width: 50,
        height: 50,
        background: secondary,
        border: "5px solid #fee4d8",
        borderRadius: 50,
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 5
    },
    '.backdrop-2': {
        color: "#CAD3DF",
        fontSize: 28,
        fontWeight: 700
    },
    '.backdrop-3': {
        color: dark,
        fontSize: 42,
        fontWeight: 700
    },
    '.section': {
        display: "flex",
        columnGap: 20,
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        rowGap: 20
    },
    '.preform-footer': {
        color: "#739DDA",
        display: "flex",
    }
}));

export const PreformAssessmentTableStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    '.assessment-actions': {
        display: "flex",
    },
    '.tooltip': {
        right: 23,
        top: 5
    },
    '.section': {
        ...sectionStyles,
        display: "flex",
        columnGap: 15,
        boxSizing: "border-box"
    },
    '.row': {
        display: "flex",
        justifyContent: "space-between",
        padding: "10px 20px"
    },
    '.row-action': {
        marginRight: 23
    }
}));

export const PreformAssessmentStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: "1rem",
    flexDirection: "column",
    rowGap: 10,
    justifyContent: "center",
    '.assessment-tutorials': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.section': {
        ...sectionStyles,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxSizing: "border-box"
    },
    '.preform-tutorials-link': {
        color: "#739DDA",
        display: "flex",
        alignItems: "center",
        columnGap: 7,
        'path': {
            fill: "#739DDA"
        }
    },
    '.assessment-actions': {
        display: "flex",
        columnGap: 10,
        '.MuiButtonBase-root.MuiButton-root': {
            borderRadius: 15,
            minWidth: 40,
            width: 47,
            height: 42
        },
        ".MuiSvgIcon-root": {
            fill: "transparent !important"
        }
    }
}));

export const TutorialStyles = muiStyled(Box)(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    background: "white",
    '.side-bar-item': {
        lineHeight: 1.2,
        'a': {
            textDecoration: "none",
            color: dark
        },
        '.MuiButtonBase-root.MuiButton-root.MuiLoadingButton-root .btn-text': {
            lineHeight: 1.3,
            // padding: 3,
        }
    },
    '.circle-border': {
        width: 80,
        height: 80,
        border: `1px solid ${secondary}`,
        borderRadius: 100,
        position: "absolute",
        background: "transparent",
    },
    '.tooltip': {
        background: thirdly2,
        height: 80,
        width: 100,
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "absolute",
    },
    '.wrap-circle-border': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3,
    },
    '.input-field': {
        borderRadius: 8,
        border: `1px solid ${thirdly3}`,
        padding: 10
    },
    '.wrap-tooltip': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3
    },
    '.item-card-light': {
        background: "white",
        padding: 20,
        borderRadius: 11,
    },
    '.full-row-item': {
        width: "100% !important"
    },
    '.table-row': {
        background: "white",
        alignItems: "center",
        padding: "11px 50px",
        display: "flex",
        justifyContent: "space-between"
    },
    '.table-col': {
    },
    '.side-bar': {
        background: "white",
        height: "100%",
        // width: 370,
        padding: 25,
        border: `1px solid ${thirdly2}`
    },
    '.item-button': {
        width: 150,
        pointerEvents: "none"
    },
    '.bold-report-actions': {
        background: "white",
        padding: 12,
        borderRadius: 15,
        position: "relative",
        bottom: 10
    },
    '.bold-report-action': {
        display: "flex",
        flexDirection: "column",
        rowGap: 5,
        alignItems: "center",
        width: 75,
        fontSize: 14,
        textAlign: "center",
        path: {
            fill: secondary
        }
    },
    '.report-actions': {
        display: "flex",
        columnGap: 10
    },
    '.wrap-report-data': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    '.item-card': {
        flexGrow: 1,
        background: bg,
        borderRadius: 7,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.row-details': {
        display: "flex",
        alignItems: "center",
        columnGap: 20
    },
    '.side-bar-title': {
        fontSize: "0.985rem",
        fontWeight: "bold",
        marginBottom: 30
    },
    '.side-bar-items': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.item-card-header': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 30
    },
    '.tutorial-content': {
        flexGrow: 1,
        padding: 30,
        overflow: "auto",
    },
    '.assessment-status': {
        border: `1px solid ${error}`,
        padding: "3px 6px",
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    '.row-item': {
        background: bg,
        width: "6rem",
        height: 20,
        borderRadius: 40
    },
    '.row': {
        ...rowStyles,
        display: "flex",
        columnGap: "1rem",
        alignItems: "center"
    },
    '.small-row-item': {
        width: "3rem"
    },
    '.row-action': {
        background: thirdly2,
        borderRadius: 3,
        width: 30,
        height: 30,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ".MuiSvgIcon-root": {
            fill: "transparent !important"
        }
    },
    '.section': {
        ...sectionStyles
    },
    '.title': {
        ...titleStyles
    },
    '.content': {
        display: "flex",
        flexDirection: "column",
        rowGap: 35,
        overflow: "auto",
        ...ScrollCss
    },
}));



export const ReportTableStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    width: "100%",
    columnGap: 15,
    '.wrap-measurement-data': {
        display: "flex",
        columnGap: 20
    },
    '.report-data': {
        display: "flex",
        columnGap: 15,
        alignItems: "center"
    },
    '.rate-and-accuracy-result': {
        border: `1px solid ${rating1}`,
        background: rating1,
        padding: "2px 5px",
        borderRadius: 5
    },
    '.rate-and-accuracy': {
        background: "white",
        padding: "2px 5px",
        borderRadius: 5
    },
    '.wrap-filter-list': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 10,
    },
    '.filter-list': {
        width: 70,
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        background: "white",
        borderRadius: 15,
        alignItems: "center",
        padding: 10,
        position: "absolute",
        right: 0,
        zIndex: 10,
        boxShadow: "0px 0px 15.9px 7px #26445A0F"

        // top: -14
    },
    '.rating-list': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.rating-item': {
        border: "1px solid black",
        width: 70,
        height: 20,
        borderRadius: 3
    },
    '.measurement-data': {
        display: "flex",
        columnGap: 20,
        alignItems: "center",
        height: 50,
        width: 130,
        '.MuiButtonBase-root.MuiIconButton-root': {
            width: 50,
            height: 50,
            background: "white",
            boxShadow: "0px 0px 42.6px 0px #5B74CE1A"
        }
    },
    '.audio-card': {
        width: "100%",
        height: 160,
        background: "white",
        borderRadius: 5
    },
    '.eye-circle-border': {
        right: 24,
        bottom: -4
    },
    '.open-report-button': {
        display: "flex",
        justifyContent: "end",
        marginTop: 10,
        pointerEvents: "none"
    },
    '.audio-col': {
        width: 250,
        height: 50
    },
    '.report-cards': {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.wrap-visibility-icon': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3,
        '.MuiButtonBase-root.MuiIconButton-root': {
            position: "absolute",
            bottom: -27,
            right: 10,
            background: "white",
            width: 55,
            height: 55,
            boxShadow: "0px 0px 42.6px 0px #5B74CE2B"
        }
    },
    '.hide-columns-feature': {
        background: "white",
        borderRadius: 15,
        padding: "3px 15px",
        display: "flex",
        flexDirection: "column",
        pointerEvents: "none"
    },
    '.wrap-row-details': {
        display: "flex",
        justifyContent: "space-between",
    },
    '.report-columns': {
        justifyContent: "space-between",
    },
    '.report-rows': {
        display: "flex",
        flexDirection: "column",
    },
    '.report-card-content': {
        display: "flex",
        width: "100%",
        // ".MuiSvgIcon-root": {
        //     fill: "transparent !important"
        // }
    },
    '.row': {
        padding: "10px 20px"
    },
    '.report-card-title': {

    },
    '.report-table': {
        display: "flex",
        columnGap: 12
    },
    '.col': {
        width: 38,
        height: 120,
        borderRadius: 15,
        background: lightSecondary
    },
    '.white-col': {
        background: "white"
    },
    '.filter-list-feature': {
        rowGap: 10
    },
    '.report-card-header': {
        display: "flex",
        justifyContent: "space-between",
        '.MuiButtonBase-root.MuiIconButton-root': {
            background: "white",
            width: 50,
            height: 50
        }
    }
}));

export const GeneralStyles = muiStyled(Box)(({ }) => ({
    height: "100%",
    width: "100%",
    fontSize: "0.95rem",
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
    '.preform-assessment-table': {
        paddingBottom: 80
    },
    '.general-content': {
        background: thirdly4,
        borderRadius: 15,
        overflow: "auto",
        ...ScrollCss
    },
    '.general-item': {
        display: "flex",
        columnGap: 25,
        padding: 20
    },
    '.general-item-card-content': {
    }
}));

export const AssessmentStyles = muiStyled(Box)(({ }) => ({
    height: "100%",
    width: "100%",
    fontSize: "0.95rem",
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
    '.assessment-content': {
        display: "flex",
        flexDirection: "column",
        rowGap: 50
    }
}));

export const ReportStyles = muiStyled(Box)(({ }) => ({
    height: "100%",
    width: "100%",
    fontSize: "0.95rem",
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
}));

export const ButtonStyles = muiStyled(Button)(({ }) => ({
    display: "flex",
    columnGap: 10,
    width: "100%",
    justifyContent: "start",
    borderRadius: 7
}));

export const GeneralReportStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: "1rem",
    rowGap: 10,
    '.wrap-wave': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3,
    },
    '.wave': {
        position: "absolute",
        width: 350,
        height: 120,
        bottom: -20,
        right: 100
    },
    '.wrap-assessment-graph': {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    '.assessment-graph': {
        background: "white",
        borderRadius: 15,
        padding: "20px 0px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
}));

export const GeneralAssessmentStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: "1rem",
    flexDirection: "column",
    rowGap: 10,
    justifyContent: "center",
    '.go-tooltip': {
        right: "10px !important",
        top: "50px !important"
    },
    '.upload-tooltip': {
        left: "-40px !important",
        top: "50px !important"
    },
    '.row': {
        ...rowStyles,
        display: "flex",
        justifyContent: "space-around"
    },
    '.assessment-arrows': {
        display: "flex",
        columnGap: 10
    }
}));

export const StudentsStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: "1rem",
    flexDirection: "column",
    justifyContent: "center",
    '.row-1': {
        width: "70%"
    },
    '.row-2': {
        width: "90%"
    }
}));

export const HomeStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: "1rem",
    justifyContent: "space-around",
    '.home-card': {
        padding: 20,
        background: "white",
        borderRadius: 15,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        rowGap: "1rem",
        width: "7rem",
        height: "5rem",
        ".MuiSvgIcon-root": {
            fill: "transparent !important"
        }
    },
    '.home-item': {
        display: "flex",
        justifyContent: "center",
        rowGap: 15,
        flexDirection: "column",
        alignItems: "center",
        width: "8rem"
    },
    '.home-description': {
        textAlign: "center"
    }
}));
